import {createSlice} from '@reduxjs/toolkit'

const partnerInfo = createSlice({
  name: 'partnerInfo',
  initialState: {
    isModalOpen: false,
  },
  reducers: {
    openModal: state => {
      state.isModalOpen = true
    },
    closeModal: state => {
      state.isModalOpen = false
    },
  },
})

export const {openModal, closeModal} = partnerInfo.actions
export default partnerInfo
